var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Tooltip",
    {
      staticClass: "flex items-center",
      attrs: {
        title: _vm.title,
        offset: 6,
        placement: "right",
        maxWidth: 340,
        variant: _vm.tooltipVariant,
        tooltipClasses: "w-82",
      },
    },
    [
      _vm._t("default", function () {
        return [_c("WarningIcon", { class: _vm.iconClasses })]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }